import { createFileTransferAdapter } from '@/adapters/fileTransfer/fileTransferAdapter';
import { apolloClient } from '@/adapters/graphql/apolloClient';

const fileTransferAdapter = createFileTransferAdapter(apolloClient);

export { fileTransferAdapter };
